import { createStore } from 'stimulus-store';

export const printerStore = createStore({
    name: 'printerStore',
    type: Object,
    initialValue: {}
});
